/**
 * Last-resort label for a data value the dictionary does not cover.
 *
 * Both domains this serves — `Lead.source` and `AnalyticsEvent.deviceType` —
 * are free-text columns, so an unknown value is reachable in production rather
 * than hypothetical. Rendering nothing would hide a real row from the reader;
 * an un-translated but readable label at least names what it is. This is the
 * same transformation the three copies of `formatSourceLabel` performed, kept
 * so an unknown value degrades exactly as it did before.
 */
export function humanizeDataValue(value: string): string {
  return value.replaceAll('_', ' ').replace(/\b\w/g, (character) => character.toUpperCase());
}
